export const MAP_MARKER =
  "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z";

export function generateMarker(color) {
  return {
    path: MAP_MARKER,
    fillColor: color,
    fillOpacity: 1,
    anchor: { x: 12, y: 24 },
    strokeWeight: 0.2,
    scale: 1.5
  };
}
